module.exports = __webpack_public_path__ + "static/media/Colette Stripe Single Headboard - 120 cm_Blush Pink.9779edab.png";